export default __webpack_public_path__ + "static/media/cmip6.b11ea42a.svg";